export const SET_IS_ZEENOW = 'SET_IS_ZEENOW';
export const USER_LOG_IN = 'USER_LOG_IN';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const USER_IS_LOGGED = 'USER_IS_LOGGED';
export const ADD_TO_PO_ITEMS = 'ADD_TO_PO_ITEMS';
export const PUSH_TO_PO_ITEMS = 'PUSH_TO_PO_ITEMS';
export const ADD_SEARCH_FILTER_QUERY = 'ADD_SEARCH_FILTER_QUERY';
export const ADD_SEARCHBAR_QUERY = 'ADD_SEARCHBAR_QUERY';
export const ADD_PO_SELECTED = 'ADD_PO_SELECTED';
export const SET_PO_END_DATE_RANGE = 'SET_PO_END_DATE_RANGE';
export const SET_PO_PAGINATION = 'SET_PO_PAGINATION';
export const UPDATE_PO_STATUS = 'UPDATE_PO_STATUS';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_PO_ITEM = 'SET_PO_ITEM';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_PAYMENTS = 'SET_PAYMENTS';
export const SET_PAYMENT_TRANSACTIONS = 'SET_PAYMENTS_TRANSACTIONS';
export const SET_PAYMENT_TRANSACTIONS_PAGINATION =
  'SET_PAYMENTS_TRANSACTIONS_PAGINATION';
export const SET_PAYMENT_TRANSACTIONS_DUE_SOON =
  'SET_PAYMENT_TRANSACTIONS_DUE_SOON';
export const ADD_PAYMENT_FILTER_QUERY = 'ADD_PAYMENT_FILTER_QUERY';
export const SET_PO_PAYMENT = 'SET_PO_PAYMENT';
export const ADD_PAYMENTS_SEARCHBAR_QUERY = 'ADD_PAYMENTS_SEARCHBAR_QUERY';
export const SET_PAYMENT_ORDER_BY = 'SET_PAYMENT_ORDER_BY';
export const SET_PAYMENT_TRANSACTIONS_ORDER_BY =
  'SET_PAYMENT_TRANSACTIONS_ORDER_BY';
export const SET_PAYMENTS_PAGINATION = 'SET_PAYMENTS_PAGINATION';
export const SET_PAYMENT_DUE = 'SET_PAYMENT_DUE';
export const SET_PAYMENTS_DUE_DATES = 'SET_PAYMENTS_DUE_DATES';
export const SET_COMMENTS_LOADING = 'SET_COMMENTS_LOADING';
export const SET_SUPPLIERS = 'SET_SUPPLIERS';
export const SET_PO_UPDATES = 'SET_PO_UPDATES';
export const SET_PO_LOADING = 'SET_PO_LOADING';
export const SET_PAYMENTS_LOADING = 'SET_PAYMENTS_LOADING';
export const SET_IS_PO = 'SET_IS_PO';
export const SET_IS_PAYMENTS = 'SET_IS_PAYMENTS';
export const SET_IS_RECEIVABLES = 'SET_IS_RECEIVABLES';
export const SET_RECEIVABLE_TRANSACTIONS = 'SET_RECEIVABLE_TRANSACTIONS';
export const SET_RECEIVABLE_TRANSACTIONS_PAGINATION =
  'SET_RECEIVABLE_TRANSACTIONS_PAGINATION';
export const SET_RT_ITEM = 'SET_RT_ITEM';
export const SET_RT_PAYMENT_STATUS = 'SET_RT_ITEM_STATUS';
export const SET_RECEIVABLE_SEARCH_QUERY = 'SET_RECEIVABLE_SEARCH_QUERY';
export const SET_RECEIVABLES_LOADING = 'SET_RECEIVABLES_LOADING';
export const SET_RECEIVABLES_FILTERS = 'SET_RECEIVABLES_FILTERS';
export const SET_RECEIVABLES_DUE_DATES = 'SET_RECEIVABLES_DUE_DATES';
export const SET_RECEIVABLE_LOADING = 'SET_RT_COMMENTS_LOADING';
export const SET_CREATING_NEW_RECEIVABLE = 'SET_CREATING_NEW_RECEIVABLE';
export const SET_IS_PO_FIRST_LOAD = 'SET_IS_PO_FIRST_LOAD';
export const SET_IS_PAYMENTS_FIRST_LOAD = 'SET_IS_PAYMENTS_FIRST_LOAD';
export const SET_IS_RECEIVABLES_FIRST_LOAD = 'SET_IS_RECEIVABLES_FIRST_LOAD';
export const SET_RECEIVABLES_ORDER_BY = 'SET_RECEIVABLES_ORDER_BY';
export const SET_NEW_RECEIVABLE_CREATED = 'SET_NEW_RECEIVABLE_CREATED';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js